import React from "react";
import { useLogin } from "./hooks";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schemas from "@/utils/schemas";
import { Box, Typography } from "@mui/material";
import { Button, Input } from "@aidergroup/ui-v2";
import { Styled } from "./styles";
import logo from "@/assets/aider.png";
import useUser from "@/context/user";
import { useNavigate } from "react-router-dom";
import { i18n } from "@/utils/i18n";
import useLocale from "@/context/locale";

const SignInForm: React.FC = () => {
    useLocale(state => state.locale);
    const onLogin = useLogin();
    const navigate = useNavigate();
    const email = useUser(state => state.email);

    const {
        handleSubmit,
        control,
        formState: { isSubmitting, isLoading, isValidating },
    } = useForm({
        resolver: yupResolver(schemas.signIn),
        defaultValues: { email: email ?? "", password: "" },
    });

    return (
        <Styled.Container>
            <form
                onSubmit={handleSubmit(
                    async ({ email, password }) => await onLogin(email, password),
                )}
            >
                <Input
                    label={i18n.t("label.email")}
                    name="email"
                    type="text"
                    control={control}
                    placeholder={i18n.t("placeholder.email")}
                    labelStyle={{ color: "white" }}
                />
                <Input
                    label={i18n.t("label.password")}
                    name="password"
                    type="password"
                    control={control}
                    placeholder={i18n.t("placeholder.password")}
                    labelStyle={{ color: "white" }}
                />
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth={true}
                    loading={isSubmitting || isLoading}
                    disabled={isSubmitting || isLoading || isValidating}
                    sx={{ margin: "5px 0px" }}
                >
                    {i18n.t("button.signIn")}
                </Button>

                <Button
                    fullWidth={true}
                    variant="outlined"
                    sx={{ margin: "5px 0px" }}
                    onClick={() => navigate("/reset-password")}
                >
                    {i18n.t("button.forgotPassword")}
                </Button>
            </form>
            <Styled.TermsBox>
                <Styled.Logo src={logo} alt="Aider Logo" />
                <Box>
                    <Typography variant="body2" sx={{ color: "#fff" }}>
                        Genom att fortsätta godkänner jag Aider Groups Användarvillkor och bekräftar
                        att jag läst Aider Groups Dataskyddsinformation.
                    </Typography>
                    <Button
                        sx={{
                            color: "#fff",
                            padding: "0px",
                            marginTop: "8px",
                            ":hover": {
                                textDecoration: "underline",
                            },
                        }}
                        onClick={() => navigate("/#")}
                    >
                        {i18n.t("button.readMore")} &nbsp; <span>↗</span>
                    </Button>
                </Box>
            </Styled.TermsBox>
        </Styled.Container>
    );
};

export default SignInForm;
